import { ref } from 'vue';


export const homeCityLandingVisible = ref(false);


export const homeMapOpen = ref(false);
